<template>
  <div>
    <!-- 顶部 -->
    <div class="header_wrap">
      <div class="header_box type_area">
        <nav class="navbar navbar-expand-lg navbar-light header_type_box">
          <a class="navbar-brand" href="javascript:;">
            <h1 style="margin: 0;">
              <img class="logo_img" src="../assets/index_img/logo.png" />
            </h1>
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i class="iconfont iconziyuan114" style="font-size: 30px;"></i>
          </button>
          <div
            class="collapse navbar-collapse"
            id="navbarNavDropdown"
            style="justify-content: flex-end;"
          >
            <ul class="navbar-nav">
              <li
                class="nav-item type_item dropdown"
                id="dropdown"
                v-for="(item, index) in navList"
                @mouseover="handleMouseOver(item, index)"
                @mouseleave="handleMouseLeave(index)"
                :key="item.Id"
              >
                <a
                  style="color: #fff;"
                  :class="[
                    'nav-link',
                    navCurrentIndex == item.Id ? 'nav_active' : ''
                  ]"
                  href="javascript:;"
                  @click="handleNavPage(item)"
                  id="navbarDropdownMenuLink"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ item.Title }}
                </a>
                <div
                  class="dropdown-menu"
                  id="dropdown-menu"
                  style="border: none;"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <a
                    class="dropdown-item"
                    v-for="item1 in item.ListHomeDhang"
                    @click="handleNavSonList(item1)"
                    :key="item1.Id"
                    href="javascript:;"
                  >
                    {{ item1.Title }}
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 大类
      navList: [],
      // 大类切换
      navActive: {},
      // seo标题
      pageSeo: {},
      // 导航切换
      navCurrentIndex: 20
    }
  },

  created() {
    this.getNavList()
    if (this.$route.query.id) {
      this.navCurrentIndex = this.$route.query.id
    }
    this.getPageSeo(this.navCurrentIndex)
  },

  methods: {
    // 获取SEO关键字
    async getPageSeo(id) {
      this.pageSeo = {}

      const { data: res } = await this.$request.post(
        `/SX_Company/GetSeoKeyWordList?SxType=${id}`
      )

      if (res.data === '') {
        document.title = '金多银多珠宝广场'
        return
      } else {
        document.title = res.data.Title
        const meta = document.createElement('meta')
        const meta1 = document.createElement('meta')
        meta.name = 'keywords'
        meta1.name = 'description'
        meta.content = res.data.KeyWord
        meta1.content = res.data.Description
        // document.getElementsByTagName('head')[0].removeChild(meta)
        // document.getElementsByTagName('head')[0].removeChild(meta1)
        document.getElementsByTagName('head')[0].appendChild(meta)
        document.getElementsByTagName('head')[0].appendChild(meta1)
      }
      this.pageSeo = res.data
    },

    // 导航列表
    async getNavList() {
      const { data: res } = await this.$request.post(
        '/SX_Company/GetDhangListV2'
      )
      this.navList = res.data
    },

    // 导航跳转
    handleNavPage(item) {
      if (item.Title === '首页') {
        this.$router.push({
          path: '/',
          query: {
            id: item.Id
          }
        })
      }
      if (item.Title === '关于我们') {
        this.$router.push({
          path: '/about-as',
          query: {
            id: item.Id
          }
        })
      }
      if (item.Title === '入驻品牌') {
        this.$router.push({
          path: '/settled-brand',
          query: {
            id: item.Id
          }
        })
      }
      if (item.Title === '品牌招商') {
        this.$router.push({
          path: '/brand-merchants',
          query: {
            id: item.Id
          }
        })
      }
      if (item.Title === '广场动态') {
        this.$router.push({
          path: '/square-dynamic',
          query: {
            id: item.Id
          }
        })
      }
      if (item.Title === '联系我们') {
        this.$router.push({
          path: '/contact-us',
          query: {
            id: item.Id
          }
        })
      }
    },

    // 导航子级跳转
    handleNavSonList(item) {
      if (this.navActive.Title === '关于我们') {
        const routeURL = this.$router.resolve({
          path: '/about-as',
          query: {
            id: this.navActive.Id,
            sonId: item.Id
          }
        })
        window.open(routeURL.href, '_blank')
        // this.$router.push({
        //   path: '/about-as',
        //   query: {
        //     id: this.navActive.Id,
        //     sonId: item.Id
        //   }
        // })
      }
      if (this.navActive.Title === '入驻品牌') {
        const routeURL = this.$router.resolve({
          path: '/about-as',
          query: {
            id: this.navActive.Id,
            sonId: item.Id
          }
        })
        window.open(routeURL.href, '_blank')
        // this.$router.push({
        //   path: '/settled-brand',
        //   query: {
        //     id: this.navActive.Id,
        //     sonId: item.Id
        //   }
        // })
      }
      if (this.navActive.Title === '品牌招商') {
        const routeURL = this.$router.resolve({
          path: '/brand-merchants',
          query: {
            id: this.navActive.Id,
            sonId: item.Id
          }
        })
        window.open(routeURL.href, '_blank')
        // this.$router.push({
        //   path: '/brand-merchants',
        //   query: {
        //     id: this.navActive.Id,
        //     sonId: item.Id
        //   }
        // })
      }
    },

    // 鼠标移入
    handleMouseOver(item, index) {
      this.navActive = item
      const dropdown = document.querySelectorAll('#dropdown')
      const dropdownMenu = document.querySelectorAll('#dropdown-menu')
      dropdown[index].classList.add('show')
      dropdownMenu[index].classList.add('show')
    },

    // 鼠标移出
    handleMouseLeave(index) {
      const dropdown = document.querySelectorAll('#dropdown')
      const dropdownMenu = document.querySelectorAll('#dropdown-menu')
      dropdown[index].classList.remove('show')
      dropdownMenu[index].classList.remove('show')
    }
  }
}
</script>

<style lang="less" scoped>
// 顶部
.header_wrap {
  background-color: #b92e32 !important;
  height: 92px;

  .header_box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo_img {
      width: 255px;
      height: 45px;
    }

    .navbar {
      display: flex;
      align-items: center;
      justify-content: space-between !important;
      padding: 0;
      width: 100%;
      height: 100%;
    }

    .header_type_box {
      display: flex;
      justify-content: flex-end;
      // justify-content: center;
      align-items: center;
      color: #fff !important;

      .type_item {
        margin: auto 32px;
        cursor: pointer;
        font-size: 16px;

        .dropdown-menu {
          left: 50%;
          transform: translateX(-50%);
          margin: 0;
          background-color: #b92e32;
          a {
            color: #fff;
            padding: 0.25rem 0.75rem;
            text-align: center;
          }
          a:hover {
            background-color: transparent;
            color: #feeb09;
          }
        }
      }

      .nav-link:hover {
        color: #feeb09 !important;
      }
    }
  }
}

// pc版心
.type_area {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

// 头部切换
.nav_active {
  color: #feeb09 !important;
}

// bootstrap
.card {
  background-color: transparent;
}

.navbar-brand {
  margin: 0;
}

.navbar-toggler {
  padding: 0 !important;
  color: #fff !important;
  border: none;
}

.dropdown-menu {
  padding: 0 0 10px;

  .dropdown-item {
    height: 40px !important;
    line-height: 40px;
    padding: 0 !important;
  }
}

@media screen and (max-width: 480px) {
  .header_wrap {
    height: 100%;
  }

  .type_area {
    width: 373px;
  }

  .logo_img {
    width: 180px !important;
    height: 45px !important;
    padding: 0.5rem 1rem !important;
  }

  .type_item {
    margin: 15px 0 !important;
    text-align: center;
  }

  .dropdown-menu {
    left: 0 !important;
    transform: translateX(0) !important;
  }

  .header_type_box {
    margin: auto;
    width: 95% !important;
  }
}

@media screen and (max-width: 767px) and (min-width: 480px) {
  .type_area {
    width: 640px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .type_area {
    width: 768px;
  }
}

/* 1024-1200px */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .type_area {
    width: 970px;
  }
}

/* 大于1200 px */
@media screen and (min-width: 1200px) {
  .type_area {
    width: 1200px;
  }
}
</style>
